// extracted by mini-css-extract-plugin
export default {"tooltip":"xS-z","arrow":"yS-z"};